import { useEffect } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { Spinner } from '@factorialco/f0-react/dist/experimental'

import { TranscriptMessages } from 'modules/meetings/components/TranscriptMesssages'
import { useMeetingTranscript } from 'modules/meetings/lib/hooks/useMeetingTranscript'
import { useRoom } from 'modules/meetings/lib/hooks/useRoom'

export const Transcript = () => {
  const { refetchTranscript, loadingTranscript } = useMeetingTranscript()
  const { isSideBarOpen } = useRoom()

  // Auto refetch every 2.5 seconds only if the sidebar is open
  useEffect(() => {
    if (!isSideBarOpen) return

    refetchTranscript()
    const interval = setInterval(() => {
      refetchTranscript()
    }, 2500)

    // Cleanup interval on unmount
    return () => clearInterval(interval)
  }, [refetchTranscript, isSideBarOpen])

  return (
    <Box flexGrow overflowY="auto" alignItems="center" justifyContent="center">
      <TranscriptMessages autoScroll />
      <Box alignItems="center" justifyContent="center" height="s24">
        {loadingTranscript && <Spinner size="small" />}
      </Box>
    </Box>
  )
}
